import { Permission, useIsUserWithPermission } from '@casops/permissions';
import { ModelName } from '@casops/store/api';
import { useAppDispatch } from '@casops/store/hooks';
import { openSidePanel, SidePanel } from '@casops/store/slices/globalSlice';
import { VdsButton } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonWithIcon from '../button-with-icon/ButtonWithIcon';

type VdsButtonProps = React.ComponentProps<typeof VdsButton>;
interface CreateItemButtonProps {
  sidePanel: SidePanel;
  modelName: ModelName;
  permission: Permission;
  disabled?: boolean;
  icon?: string;
  label?: string;
  variant?: VdsButtonProps['variant'];
}

export const CreateItemButton = ({
  sidePanel,
  modelName,
  permission,
  disabled = false,
  icon = 'add',
  label,
  variant = 'primary',
}: CreateItemButtonProps): ReactElement | null => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const isShow = useIsUserWithPermission(permission);

  const onClick = useCallback(() => {
    dispatch(openSidePanel({ sidePanel, editMode: false }));
  }, [dispatch, sidePanel]);

  return isShow ? (
    <ButtonWithIcon
      variant={variant}
      icon={icon}
      label={label ?? t('Model.Create.Title', { modelName })}
      onClick={onClick}
      disabled={disabled}
    />
  ) : null;
};

export default CreateItemButton;
